<template>
    <div class="insurance-search-bar-container">
        <div class="destination-container">
            <div class="word-container white hd-16">
                {{$t('web.travel-insurance-search-bar.destination')}}
            </div>
            <div class="search-container">
<!--                <Select2 v-model="myValue" :options="myOptions" :settings="{ settingOption: value, settingOption: value }" @change="myChangeEvent($event)" @select="mySelectEvent($event)" />-->

                <div class="input-container">
                    <div class="control has-icons-right">
                        <input @input="checkDestination" class="input hd-16" type="text" :placeholder="$t('web.travel-sims.search-placeholder')" v-model="searchString">
<!--                        <span class="icon is-small is-right"><i class="far fa-angle-down"></i></span>-->
                    </div>
                    <div class="country-select-container">
                        <ul>
                            <li v-if="isCountrySelectorShown" v-for="country in filteredCountries" @click.prevent="selectCountry($t('country.' + country.country.slug))">
                                <a class="hd-18">
                                    <i class="fas fa-map-marker-alt"></i> {{ $t('country.' + country.country.slug) }}
                                </a>
                            </li>
                            <li class="no-this-place-container" v-if="showNoPlace">
                                <p class="hd-18">{{ $t('web.travel-sims.country-search-no-place-found') }}</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="date-container">
            <div class="word-container white hd-16">
                {{$t('web.travel-insurance-search-bar.date')}}
            </div>
            <div class="datepicker-trigger">
<!--                <input-->
<!--                        type="text"-->
<!--                        id="datepicker-trigger"-->
<!--                        placeholder="SELECT DATE"-->
<!--                        :value="formatDates(dateOne, dateTwo)"-->
<!--                >-->
                <button id="datepicker-button-trigger">{{formatDates(dateOne, dateTwo)}}<i class="far fa-angle-down"></i></button>

                <AirbnbStyleDatepicker
                        :trigger-element-id="'datepicker-button-trigger'"
                        :mode="'range'"
                        :fullscreen-mobile="true"
                        :min-date="firstDay"
                        :end-date="lastDay"
                        :date-one="dateOne"
                        :date-two="dateTwo"
                        @date-one-selected="val => { dateOne = val }"
                        @date-two-selected="val => { dateTwo = val }"
                ></AirbnbStyleDatepicker>
            </div>
        </div>
        <div class="number-of-traveller-container">
            <div class="word-container white hd-16">
                {{$t('web.travel-insurance-search-bar.number-of-traveller')}}
            </div>
            <div class="quantity-selector">
                <div @click.prevent="selectNumberOfTraveller" class="click-box hd-16">{{countNumberOfTraveller}}<i class="far fa-angle-down"></i></div>
                <div v-if="isNumberOfTravellerSelectorShown" class="checkbox-container">
                    <label class="checkbox hd-18">
                        <input v-model="form.myself" type="checkbox">
                        {{$t('web.travel-insurance-search-bar.myself')}}
                    </label>
                    <label class="checkbox hd-18">
                        <input v-model="form.spouse" type="checkbox">
                        {{$t('web.travel-insurance-search-bar.spouse')}}
                    </label>
                    <label class="checkbox hd-18">
                        <input v-model="form.children" type="checkbox">
                        {{$t('web.travel-insurance-search-bar.children')}}
                    </label>
                    <div v-if="form.children" class="select">
                        <select v-model="form.number_of_children">
                            <option :value="i" v-for="i in 20">{{ i }}</option>
                        </select>
                    </div>
                    <label class="checkbox hd-18">
                        <input v-model="form.friends" type="checkbox">
                        {{$t('web.travel-insurance-search-bar.friend')}}
                    </label>
                    <div v-if="form.friends" class="select">
                        <select v-model="form.number_of_friends">
                            <option :value="i" v-for="i in 20">{{ i }}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div class="search-button-container">
            <button @click.prevent="quoteInsurance" class="search-button button hd-18 white" v-bind:class="{'is-loading': isLoading}">
                <i class="fas fa-search hd-16"></i>
                {{$t('web.travel-insurance-search-bar.search-button')}}
            </button>
        </div>
    </div>
</template>

<script>
    import format from 'date-fns/format'
    import moment from 'moment'
    import Select2 from 'v-select2-component';

    let firstDay = moment().subtract(1,'days').format();
    let lastDay = moment().add(268,'days').format();

    export default {
        components:{Select2},
        props: {
            countries: Array,
        },


        data(){
            return {
                searchString: "",
                countriesWithTranslation: [],
                filteredCountries:[],
                selectedCountry:[],
                dateFormat: 'D MMM YYYY',
                dateOne: '',
                dateTwo: '',
                firstDay: firstDay,
                lastDay: lastDay,
                isNumberOfTravellerSelectorShown:false,
                isCountrySelectorShown:false,
                isDatePickerShown: false,
                isLoading: false,
                showNoPlace: false,
                myValue: '',
                myOptions: [],
                form:{
                    myself: true,
                    spouse: false,
                    children: false,
                    friends: false,
                    number_of_children: 1,
                    number_of_friends: 1,
                },

            }
        },

        computed: {
            // filteredCountries(){
            //     return this.countriesWithTranslation.filter(country => {
            //         if(this.searchString == "") return false;
            //             return country.slug.includes(this.searchString.replace(/\s/g, '').toLowerCase());
            //     });
            // },

            // showNoPlace(){
            //     return this.searchString != "" && this.filteredCountries && this.filteredCountries.length == 0
            // },

            countNumberOfTraveller(){
                return this.form.myself + this.form.spouse + (this.form.children === true ? this.form.number_of_children : 0) + (this.form.friends === true ? this.form.number_of_friends : 0)
            },
        },

        methods: {
            myChangeEvent(val){
                console.log(val);
            },
            mySelectEvent({id, text}){
                console.log({id, text})
            },
            formatDates(dateOne, dateTwo) {
                let formattedDates = '';
                if (dateOne) {
                    formattedDates = format(dateOne, this.dateFormat)
                }
                if (dateTwo) {
                    formattedDates += ' - ' + format(dateTwo, this.dateFormat)
                }
                return formattedDates
            },

            selectCountry(country) {
                this.searchString = country;
                this.isCountrySelectorShown = false;
            },

            selectNumberOfTraveller(){
                this.isNumberOfTravellerSelectorShown = !this.isNumberOfTravellerSelectorShown;
            },

            checkDestination(){
                if (this.searchString !== '') {
                    this.filteredCountries = this.countriesWithTranslation.filter(country => {
                        return country.slug.includes(this.searchString.replace(/\s/g, '').toLowerCase())
                    });
                    this.isCountrySelectorShown = true;
                } else {
                    this.isCountrySelectorShown = false;
                }
                if (this.searchString !== '' && this.filteredCountries && this.filteredCountries.length === 0){
                    this.showNoPlace = true;
                } else {
                    this.showNoPlace = false;
                }
            },

            quoteInsurance(){
                if (this.searchString === ''){
                    this.showNoPlace = true;
                    return false
                } else if (this.countNumberOfTraveller === 0){
                    this.isNumberOfTravellerSelectorShown = true;
                    return false
                }
                this.filteredCountries = this.countriesWithTranslation.filter(country => {
                    return country.slug.includes(this.searchString.replace(/\s/g, '').toLowerCase())
                });
                const url = window.location.protocol + "//" + window.location.host + "/travel-insurance-quote-redirect";
                const paramString = new URLSearchParams({
                    country_id: this.filteredCountries[0].country.id,
                    myself:this.form.myself === true ? 1 : 0,
                    spouse:this.form.spouse === true ? 1 : 0,
                    children:this.form.children === true ? this.form.number_of_children : 0,
                    friends:this.form.friends === true ? this.form.number_of_friends : 0,
                    start_date:this.dateOne,
                    end_date:this.dateTwo
                });
                this.isLoading = true;
                // alert(`${url}?${paramString.toString()}`);
                window.location = `${url}/${paramString.toString()}`;
            }

        },

        mounted() {
            for(let country of this.countries){
                this.countriesWithTranslation.push({
                    country: country,
                    slug: (this.$t('country.' + country.slug, "en-US") + this.$t('country.' + country.slug, "zh-HK")).replace(/\s/g, '').toLowerCase()
                });
            }
            // for(let country of this.countries){
            //     this.myOptions.push(this.$t('country.'+ country.slug));
            //
            // }
            if (window.location.search !== '') {
                const url = new URLSearchParams(window.location.search);
                if (parseInt(url.get('myself')) === 1) {
                    this.form.myself = true;
                }else{
                    this.form.myself = false;
                }
                if (parseInt(url.get('spouse')) === 1) {
                    this.form.spouse = true;
                }else{
                    this.form.spouse = false;
                }
                if (url.get('children') !== '0'){
                    this.form.children = true;
                    this.form.number_of_children = parseInt(url.get('children'));
                }
                if (url.get('friends') !== '0'){
                    this.form.friends = true;
                    this.form.number_of_friends = parseInt(url.get('friends'));
                }
                this.dateOne = url.get('start_date');
                this.dateTwo = url.get('end_date');
                const country = this.countriesWithTranslation.filter( country => {
                    return country.country.id == url.get('country_id');
                });
                this.searchString = this.$t('country.'+ country[0].country.slug);
            } else {
                this.dateOne = moment().format();
                this.dateTwo = moment().add(4,'days').format();
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../sass/_mixin.scss";
    .insurance-search-bar-container{
        display: flex;
        @include responsive(){
            display: block;
        }
        .word-container{
            margin-bottom: 8px;
        }
        .destination-container{
            .search-container{
                width: 170px;
                height: 64px;
                margin-right: 8px;
                @include responsive(){
                    width: 100%;
                }
                .input:focus{
                    border-color: #dbdbdb;
                    box-shadow: inset 0 1px 2px rgba(51, 51, 51, 0.1);
                }

                .input-container{
                    display: flex;
                    justify-content: center;
                    /*max-width: 500px;*/
                    margin: auto;
                    position: relative;
                    width: 100%;
                    height: 100%;


                    .control{
                        width: 100%;
                        height: 100%;

                        .input{
                            border-radius: 8px;
                            height: 100%;
                            padding: 16px;
                            box-shadow: unset;
                            border: 1px solid #F7F7F7;
                        }
                        .icon {
                            height: 4.5em;
                            width: unset;
                            right: 16px;
                            .far {
                                right: 0;
                                color: #000000;
                            }
                            @include responsive(){
                                z-index: 1;
                            }
                        }
                    }

                    .country-select-container{
                        position: absolute;
                        left: 0;
                        top: 100%;
                        width: 100%;
                        max-height: 300px;
                        overflow: auto;
                        z-index: 10;
                        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
                        border-radius: 5px;
                        margin-top: 4px;
                        @include responsive(){
                            z-index: 1;
                        }

                        ul{
                            li{
                                &:before {
                                    display: none;
                                }
                                padding-left: 0;

                                a {
                                    padding: 12px 16px;
                                    text-align: left;
                                    background-color: #FFF;
                                    transition: all 0.25s;
                                    color: #707070;
                                    display: block;

                                    i{
                                        margin-right: 6px;
                                    }

                                    &:not(:last-child) {
                                        border-bottom: 1px solid #DEDEDE;
                                    }

                                    &:hover {
                                        color: #FFF;
                                        background-color: #0176EE;
                                    }
                                }

                                &.no-this-place-container{
                                    padding: 40px 0;
                                    background: #FFF;
                                    text-align: center;
                                }
                            }
                        }
                    }
                }
            }
        }
        .date-container{
            margin-right: 8px;
            @include responsive(){
                margin-right: unset;
            }
            .word-container{
                @include responsive() {
                    margin-top: 8px;
                }
            }
            .datepicker-trigger{
                height: 64px;
                width: 270px;
                @include responsive(){
                    width: 100%;
                }
                button{
                    width: 100%;
                    height: 100%;
                    border-radius: 8px;
                    border: 1px solid #F7F7F7;
                    background: #FFFFFF;
                    padding: 16px;
                    position: relative;
                    font-size: 16px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    cursor: pointer;
                    &:focus{
                        outline: none;
                    }
                    .far{
                        pointer-events: none;
                    }
                }
                .asd__wrapper{
                    margin-top: 4px;
                    border-radius: 5px;
                    @include responsive(){
                        margin: unset;
                        position: fixed;
                        top: 0;
                        left: 0;
                        height: 100%;
                        z-index: 100;
                        width: 100%;
                        overflow: auto;
                        border-radius: unset;
                    }
                }

            }
        }
        .number-of-traveller-container{
            margin-right: 8px;
            @include responsive(){
                margin-right: unset;
            }
            .word-container{
                @include responsive() {
                    margin-top: 8px;
                }
            }
            .quantity-selector{
                position: relative;
                .click-box{
                    height: 64px;
                    width: 100%;
                    min-width: 106px;
                    background: #FFFFFF;
                    border: 1px solid #F7F7F7;
                    box-sizing: border-box;
                    border-radius: 8px;
                    display: flex;
                    align-items: center;
                    padding: 16px;
                    position: relative;
                    cursor: pointer;
                    @include responsive(){
                        justify-content: flex-start;
                        width: 50%;
                        padding: 16px;
                    }
                    .far{
                        position: absolute;
                        right: 16px;
                    }
                }
                .checkbox-container{
                    position: absolute;
                    padding: 16px;
                    left: 0;
                    top: 100%;
                    width: 200px;
                    overflow: auto;
                    z-index: 2;
                    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
                    border-radius: 5px;
                    margin-top: 4px;
                    background: #FFFFFF;
                    .checkbox{
                        display: block;
                        margin-bottom: 8px;
                    }
                }
            }
        }
        .search-button-container{
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            @include responsive(){
                margin-top: 16px;
            }
            button{
                background: #59D876;
                border-radius: 8px;
                height: 64px;
                width: 123px;
                border-color: transparent;
                @include responsive(){
                    width: 100%;
                }
                .fas{
                    margin-right: 8px;
                }
                &:hover{
                    color: #FFF;
                }
            }
        }
    }

</style>
<style lang="scss">
    .destination-container{
        .search-container{
            .select2{
                width: 100% !important;
                height: 100% !important;
                .select2-selection{
                    height: 100%;
                    border: none;
                    border-radius: 8px;
                    display: flex;
                    align-items: center;
                    padding: 16px;
                }
                .select2-selection__arrow{
                    display: none;
                }
            }
        }
    }
    .select2-dropdown{
        margin-top: 4px !important;
        border-radius: 5px;
        border-top: 1px solid #aaa !important;
        .select2-search{
            border-radius: 0 5px 5px 0;
        }
    }
    .asd__inner-wrapper{
        .asd__day--selected{
            background: #31B04E!important;
        }
        .asd__day--in-range{
            background: #59D876 !important;
        }
    }
    .asd__keyboard-shortcuts-trigger{
        display: none !important;
    }
</style>
